<template>
  <div id="app">
    <template v-if="$auth.loading">
      <base-loader fullscreen />
    </template>
    <template v-else>
      <the-header />
      <the-container >
        <router-view />
      </the-container>
    </template>
  </div>
</template>

<script>
import TheContainer from '@/components/TheContainer.vue'
import TheHeader from '@/components/TheHeader.vue'

export default {
  components: {
    TheContainer,
    TheHeader
  },

  watch: {
    $route: {
      deep: true,
      handler () {
        const { fullPath, hash } = this.$route

        this.$crm.setPath(fullPath)

        if (hash) {
          setTimeout(() => {
            this.$window.scrollToElementById(hash.substring(1))
          }, 200)
        }
      }
    }
  }
}
</script>
